
import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

import RegisterMunchenForm from "./RegisterMunchen/RegisterMunchenApp";
import PrecitaReferentesResonaForm from "./PrecitaReferentesResona/PrecitaReferentesResonaApp";
import PrecitaPacientesResonaForm from "./PrecitaPacientesResona/PrecitaPacientesResonaApp";

require('dotenv').config();

const App = () => (
    <Router basename="/register">
        <Switch>
            <Route exact path="/" />
            <Route exact path="/precitapacientes" component={PrecitaPacientesResonaForm} />
            <Route path="/precitareferentes" component={PrecitaReferentesResonaForm} />
            <Route path="/doctorsregister" component={RegisterMunchenForm} />
        </Switch>
    </Router>
);

export default App;
// You can think of these components as "pages"
// in your app.

